import { render, staticRenderFns } from "./SimulationDetail.vue?vue&type=template&id=1b7144ea&scoped=true"
import script from "./SimulationDetail.vue?vue&type=script&lang=ts"
export * from "./SimulationDetail.vue?vue&type=script&lang=ts"
import style0 from "./SimulationDetail.vue?vue&type=style&index=0&id=1b7144ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7144ea",
  null
  
)

export default component.exports